import * as React from 'react';
import { 
  Text, 
  TextInput, 
  StyleSheet, 
  View,
  TouchableOpacity
} from 'react-native';
import { useField } from 'formik';

import InputIcon from './InputIcon';
// import { TouchableOpacity } from 'react-native-gesture-handler';
import SelectListModal from '../modals/SelectListModal';
import StyledIcon from '../StyledIcon';
import Colors from '../../constants/Colors'
import FontStyles from '../../constants/FontStyle';

export default function FormikSelectList({ label, fieldName, placeholder, ...props }) {
  const [field, meta, helpers] = useField(fieldName);
  const [selected, setSelected] = React.useState('')
  const [modalState, setModalState] = React.useState(false);

  const hideModal = () => {
    setModalState(false)
  }

  const modalCallback = (data) => {
    helpers.setValue(data?._id)
    setSelected(data)
    hideModal()
  }


  React.useEffect(() => {
    // set initial value
    if (meta.initialValue && props.options) {
      let init = props.options.find(item => item._id === meta.initialValue)
      if (init) {
        helpers.setValue(meta.initialValue)
        setSelected(init)
      }
    }
  }, [props.options, meta.initialValue])

  return (
    <>
      <SelectListModal modalState={modalState} hideModal={hideModal} callback={modalCallback} options={props?.options} label={label} placeholder={placeholder} />
      {props.options && props.options.length
        ? <>
          {label ? <Text style={styles.inputLabel}>{label}</Text> : null}
          <TouchableOpacity
            onPress={() => setModalState(true)}
            style={[
              styles.inputGroup,
              {
                borderColor: Colors.inputBorderColor,
                paddingRight: 16,
                alignItems: 'center'
              }
            ]}
          >
            <Text
              style={[styles.inputControl, {
                flex: 1,
                color: selected ? Colors.darkTextColor : Colors.greyColor,
              }]}
            >{ selected ? selected.name : placeholder ? placeholder : 'Select an option' }</Text>

            <StyledIcon
              iconName="chevron-down"
              iconColor={Colors.greyColor}
              iconOnly
              style={{
              }}
            />
          </TouchableOpacity>
         
          <View style={{ position: 'relative' }}>
            {meta.touched && meta.error ? (
              <Text style={styles.error}>{meta.error}</Text>
            ) : null}
            
          </View>

        </>
        : null}
    </>
  );
};

const styles = StyleSheet.create({
  inputLabel: {
    color: Colors.shades._7,
    ...FontStyles.size14,
    ...FontStyles.lh16,
    ...FontStyles.medium,
    marginBottom: 2,
    marginTop: 20
  },
  inputGroup: {
    flexDirection: 'row',
    height: 40,
    // borderColor: '#EAEAEA',
    // borderWidth: 1,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
  },
  inputGroupFocus: {
    flexDirection: 'row',
    height: 40,
    // borderColor: '#3B54EC',
    // borderWidth: 1,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
  },
  inputControl: {
    flexGrow: 1,
    color: Colors.darkTextColor,
    ...FontStyles.size15,
    ...FontStyles.lh20,
    ...FontStyles.normal,
  },
  error: {
    color: '#ED4067',
    ...FontStyles.size10,
    ...FontStyles.normal,
  },
  dropdown: {
    position: 'absolute',
    zIndex: 1,
    left: 5,
    right: 5,
    borderRadius: 6,
    borderColor: '#EAEAEA',
    borderWidth: 1,
    borderStyle: 'solid',
    overflow: 'hidden',
    elevation: 5,
    backgroundColor: 'white'
  },
  dropdownItem: {
    padding: 10,
    backgroundColor: 'white',
  },
  borderLine: {
    borderBottomColor: '#EAEAEA',
    borderBottomWidth: 1,
    borderStyle: 'solid'
  }
})